import { useEffect, useState } from 'react';
import { useFinancialsStore } from './financials-store';

/**
 * Tracks when the persisted financials store has finished hydrating from storage.
 * Prevents components from running queries with incomplete (pre-hydration) filter values.
 *
 * @returns {boolean} True if the financials store has finished hydrating, false otherwise.
 */
function useFinancialsStoreHydration(): boolean {
  const [hasHydrated, setHasHydrated] = useState(() => {
    return typeof useFinancialsStore.persist?.hasHydrated === 'function'
      ? useFinancialsStore.persist.hasHydrated()
      : true;
  });

  useEffect(() => {
    const unsubHydrate = useFinancialsStore.persist?.onHydrate?.(() => {
      setHasHydrated(false);
    });

    const unsubFinish = useFinancialsStore.persist?.onFinishHydration?.(() => {
      setHasHydrated(true);
    });

    return () => {
      unsubHydrate?.();
      unsubFinish?.();
    };
  }, []);

  return hasHydrated;
}

export { useFinancialsStoreHydration };
